module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("WHO DO YOU THINK YOU ARE?")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0007-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_vm._v("CONTENTS"), _c('br'), _c('br')])]), _c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-02-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter3#toc1",
      "id": "con1"
    }
  }, [_vm._v("1. I Am _________?")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-P-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter4#toc2",
      "id": "con2"
    }
  }, [_vm._v("2. I Am in Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-P-2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#toc3",
      "id": "con3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. I Am a Saint")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-P-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#toc4",
      "id": "con4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. I Am Blessed")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-P-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#toc5",
      "id": "con5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. I Am Appreciated")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-P-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#toc6",
      "id": "con6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. I Am Saved")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-P-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#toc7",
      "id": "con7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. I Am Reconciled")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-P-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#toc8",
      "id": "con8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. I Am Afflicted")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0007-P-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#toc9",
      "id": "con9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. I Am Heard")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#toc10",
      "id": "con10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. I Am Gifted")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#toc11",
      "id": "con11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. I Am New")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#toc12",
      "id": "con12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. I Am Forgiven")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#toc13",
      "id": "con13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. I Am Adopted")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#toc14",
      "id": "con14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. I Am Loved")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#toc15",
      "id": "con15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. I Am Rewarded")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#toc16",
      "id": "con16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. I Am Victorious"), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#toc17",
      "id": "con17",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#toc18",
      "id": "con18",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#toc19",
      "id": "con19",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author ")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "p0007-P-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/index1#toc20",
      "id": "con20",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0